import { React, useEffect, useMemo, useState } from 'react'
import {Modal,Button} from "react-bootstrap";
import "../Appv2"
import swal from 'sweetalert';
import Cookies from 'universal-cookie/es6';

const api=process.env.REACT_APP_API;

const WEEK_DAYS = ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"];
const MONTHS_ES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const pad2 = (value) => String(value).padStart(2, "0");

const toDateKey = (rawDate) => {
  if (!rawDate) return "";

  if (typeof rawDate === "string") {
    return rawDate.substring(0, 10);
  }

  if (rawDate instanceof Date && !Number.isNaN(rawDate.getTime())) {
    return `${rawDate.getFullYear()}-${pad2(rawDate.getMonth() + 1)}-${pad2(rawDate.getDate())}`;
  }

  return "";
};

const parseISODate = (value) => {
  if (!value || typeof value !== "string") return null;

  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return null;

  return new Date(year, month - 1, day);
};

const toHourMinute = (value) => {
  if (!value) return "";
  return String(value).substring(0, 5);
};

const toMinutes = (value) => {
  const hourMinute = toHourMinute(value);
  if (!hourMinute) return null;

  const [hourRaw, minuteRaw] = hourMinute.split(":").map(Number);
  if (Number.isNaN(hourRaw) || Number.isNaN(minuteRaw)) return null;

  return hourRaw * 60 + minuteRaw;
};

const toReadableHour = (value) => {
  const hourMinute = toHourMinute(value);
  if (!hourMinute) return "";

  const [hourRaw, minuteRaw] = hourMinute.split(":").map(Number);
  const safeHour = Number.isNaN(hourRaw) ? 0 : hourRaw;
  const safeMinute = Number.isNaN(minuteRaw) ? 0 : minuteRaw;
  const suffix = safeHour >= 12 ? "PM" : "AM";
  const hour12 = safeHour % 12 || 12;

  return `${hour12}:${pad2(safeMinute)} ${suffix}`;
};

const getCalendarCells = (baseDate) => {
  const year = baseDate.getFullYear();
  const month = baseDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const totalDays = new Date(year, month + 1, 0).getDate();
  const offset = (firstDay.getDay() + 6) % 7;
  const cells = [];

  for (let i = 0; i < offset; i += 1) {
    cells.push(null);
  }

  for (let day = 1; day <= totalDays; day += 1) {
    cells.push(day);
  }

  while (cells.length % 7 !== 0) {
    cells.push(null);
  }

  return cells;
};

function Card({ id, Nombre, Edificio, N_piso, Tamaño, N_personas, Estado, img, img2 }) {
    const [lgShow, setLgShow] = useState(false);
    const cookies=new Cookies();
    const correo_Electronico=cookies.get("correo_Electronico")
    const nombrePersona=cookies.get("nombre")
    const apellidoPersona=cookies.get("apellido")
    
    const nombreUsuario=cookies.get("nombre_Usuario")
    const [codigo] = useState(id)
    const [dia, setDia] = useState("")
    const [inicio, setInicio] = useState("")
    const [fin, setFin] = useState("")
    const [estado] = useState("Pendiente")
    const [edificio]=useState(Edificio)
    const [nombre]= useState(Nombre)
    const [fecha,setFecha]= useState("")
    const [calendarMonth, setCalendarMonth] = useState(new Date())
    const [calendarRows, setCalendarRows] = useState([])
    const [calendarLoading, setCalendarLoading] = useState(false)
    const [inspectedDayKey, setInspectedDayKey] = useState("")
    const [todayDate] = useState(() => {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    })

    const selectedStartTime = toHourMinute(inicio)
    const selectedDayKey = toDateKey(dia)
    const inspectedDayDate = parseISODate(inspectedDayKey)
    const inspectedDayLabel = inspectedDayDate
      ? `${inspectedDayDate.getDate()} de ${MONTHS_ES[inspectedDayDate.getMonth()]} de ${inspectedDayDate.getFullYear()}`
      : ""
    const canGoToPreviousMonth =
      calendarMonth.getFullYear() > todayDate.getFullYear() ||
      (calendarMonth.getFullYear() === todayDate.getFullYear() &&
        calendarMonth.getMonth() > todayDate.getMonth())

    const calendarDayMap = useMemo(() => {
      const groupedByDay = {};

      calendarRows.forEach((row) => {
        const dayKey = toDateKey(row.dia);
        const hourStart = toHourMinute(row.hora_Inicio);
        const hourEnd = toHourMinute(row.hora_fin || row.hora_Fin);

        if (!dayKey || !hourStart) return;

        if (!groupedByDay[dayKey]) {
          groupedByDay[dayKey] = [];
        }

        groupedByDay[dayKey].push({ start: hourStart, end: hourEnd });
      });

      Object.keys(groupedByDay).forEach((dayKey) => {
        groupedByDay[dayKey].sort((a, b) => a.start.localeCompare(b.start));
      });

      return groupedByDay;
    }, [calendarRows]);

    const inspectedReservations = useMemo(() => {
      if (!inspectedDayKey) return [];
      return calendarDayMap[inspectedDayKey] || [];
    }, [calendarDayMap, inspectedDayKey]);

    const calendarCells = useMemo(() => getCalendarCells(calendarMonth), [calendarMonth]);

    const cargarReservasCalendario = async (baseDate) => {
      setCalendarLoading(true);

      try {
        const res = await fetch(`${api}/disponibilidadCalendario`, {
          method: "put",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            edificio,
            sala: nombre,
            year: baseDate.getFullYear(),
            month: baseDate.getMonth() + 1,
          }),
        });

        const data = await res.json();
        setCalendarRows(Array.isArray(data) ? data : []);
      } catch (error) {
        console.log(error);
        setCalendarRows([]);
      } finally {
        setCalendarLoading(false);
      }
    };

    useEffect(() => {
      if (!lgShow) return;
      cargarReservasCalendario(calendarMonth);
    }, [lgShow, calendarMonth]);

    useEffect(() => {
      if (!lgShow || !selectedDayKey) return;
      setInspectedDayKey(selectedDayKey);
    }, [lgShow, selectedDayKey]);

    const getDayStatus = (dayNumber) => {
      if (!dayNumber) return "none";

      const dayKey = `${calendarMonth.getFullYear()}-${pad2(calendarMonth.getMonth() + 1)}-${pad2(dayNumber)}`;
      const reservations = calendarDayMap[dayKey] || [];

      if (reservations.length === 0) return "none";

      const exactMatch = selectedStartTime && reservations.some((reservation) => reservation.start === selectedStartTime);
      if (exactMatch) return "busy";

      return "partial";
    };

    
    

const handleSubmit=()=>{
  handleSubmit1().then(response=>{handleSubmit2(response)}).then(message())
}



    const handleSubmit1 = async (e) => {
          
      
      const res= await fetch(`${api}/agregar`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                dia,
                inicio,
                fin,
                estado,
                codigo,
                correo_Electronico
            })

        });

        const data=await res.json();

        return  data;        
    }

    const handleSubmit2 =async (response) => {
        await fetch(`${api}/correo`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                edificio,
                nombre,
                dia,
                inicio,
                fin,
                correo_Electronico,
                N_piso,
                nombreUsuario,
                response,
                nombrePersona,
                apellidoPersona
            })
        })
    }

    const message = () => {
    swal({
        title: "Solicitud de Reserva de Salas Creadas",
        text: "Solicitud de Reserva Enviada. Se le Notificará Mediante Correo Electrónico si su Reserva es Confirmada/Rechazada",
        icon: "success",
        button: "Aceptar",
    });
    setDia("");
    setInicio("");
    setFin("");
    };
    
    const Fecha=()=>{
        const fecha2=new Date()
        var año=fecha2.getFullYear();
        var mes= fecha2.getMonth()+1;
        var dia=fecha2.getDate();
        var hora=fecha2.getHours();
        var minutos=fecha2.getMinutes();
        
        if(hora<10){
            hora="0"+hora
        }

        if(minutos<10){
            minutos="0"+minutos
        }


        if(dia<10){
            dia="0"+dia
        }

        if(mes<10){
            mes="0"+mes
        }
        setFecha(año+"-"+mes+"-"+dia)
    }


    const validacion=(e)=>{
        e.preventDefault();
    /*    var day = diaActual.getDate();
        var month = diaActual.getMonth()+1;
        var year = diaActual.getFullYear();
        var hour =diaActual.getHours();
        dia.charAt(0)
        dia.charAt(1)
        dia.charAt(2)
        dia.charAt(3)
        dia.charAt(5)
        dia.charAt(6)
        dia.charAt(8)
        dia.charAt(9)
       var añoR=dia.charAt(0)+dia.charAt(1)+dia.charAt(2)+dia.charAt(3);
        var mesR=dia.charAt(5)+dia.charAt(6)
        var diaR=dia.charAt(8)+dia.charAt(9)

        if(month===mesR && year===añoR && day===diaR){
            var resta=12-parseInt(inicio)
            if(resta<=hour){
                swal({
                    title: "Error al Crear Solicitud",
                    text: "Para Poder Crear Una Solicitud de Sala se debe de hacer con 12 horas de Anticipación",
                    icon: "error",
                    button: "Aceptar"
                })
            }else{
                handleSubmit();
            }
            */
        if(dia==="" || inicio==="" || fin==="" ){
            swal({
                title: "Validacion de Datos",
                text: "Todos los Campos Deben de Estar Completo",
                icon: "warning",
                button: "Aceptar"
            })
        }
        else if(hayConflictoHorario()){
            swal({
                title: "Horario No Disponible",
                text: "Ya existe una reserva confirmada en ese día y horario para esta sala. Por favor elige otro horario o día.",
                icon: "error",
                button: "Aceptar"
            })
        }
        else{
            handleSubmit()
        }
    }

    const hayConflictoHorario = () => {
      const dayKey = toDateKey(dia);
      const reservations = calendarDayMap[dayKey] || [];

      const newStart = toMinutes(inicio);
      const newEnd = toMinutes(fin);
      if (newStart === null || newEnd === null) return false;

      return reservations.some((reservation) => {
        const existingStart = toMinutes(reservation.start);
        const existingEnd = toMinutes(reservation.end);
        if (existingStart === null) return false;

        const safeExistingEnd = existingEnd === null ? existingStart : existingEnd;
        return newStart < safeExistingEnd && newEnd > existingStart;
      });
    };

    const tieneConflicto = useMemo(
      () => hayConflictoHorario(),
      [dia, inicio, fin, calendarDayMap]
    );

    const isAvailable = Estado === "Disponible";


    return (
      <div className="card text-center bg-dark rs-room-card">
        <div className="card-body text-light rs-room-body">
          <div className="rs-room-photo-wrap">
            <img src={img} className="img-fluid rs-room-photo" style={{backgroundColor:"white"}} alt="Imagen de sala" />
          </div>
          <h4 className="card-title rs-room-title">{Nombre}</h4>

          <div className="rs-room-meta">
            <p><strong>Edificio:</strong> {Edificio}</p>
            <p><strong>N° de Piso:</strong> {N_piso}</p>
            <p><strong>Tamaño:</strong> {Tamaño}</p>
            <p><strong>N° de personas:</strong> {N_personas}</p>
          </div>

          <p className="rs-room-status-line">
            <strong>Estado:</strong>{" "}
            <span className={`rs-room-status ${isAvailable ? "is-available" : "is-unavailable"}`}>
              {Estado}
            </span>
          </p>
        </div>
        {
          isAvailable ?  <Button
          variant="primary"
          className="rs-room-cta"
          onClick={() => {
            Fecha();
            setCalendarMonth(parseISODate(dia) || new Date());
            setLgShow(true);
          }}
        >
          Solicitud de Reserva
        </Button>:null
        }
      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton className="App">
            <Modal.Title id="example-modal-sizes-title-lg">
              {" "}
              Solicitud de Reserva {Nombre}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="App" style={{ maxHeight: "calc(100vh - 170px)", overflowY: "auto" }}>
            <div className="container-fluid text-center px-1">
              <div className="row g-3">
                <div className="col-12 col-lg-6 text-light bg-dark p-4" style={{ borderRadius: 10 }}>
                  <h4 className="text-center">Crear Reservar</h4>
                  <form className="row text-start" onSubmit={validacion}>
                    <div className="p-2">
                      <label htmlFor="dia" className="form-label">
                        Día a Reservar
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="dia"
                        min={fecha}
                        onChange={(e) => {
                          const value = e.target.value;
                          const selectedDate = parseISODate(value);

                          setDia(value);

                          if (selectedDate) {
                            setCalendarMonth(selectedDate);
                          }
                        }}
                        value={dia}
                        autoFocus
                      />
                    </div>
                    <div className="p-2">
                      <label htmlFor="minutos" className="form-label">
                        Hora de Inicio
                      </label>
                      <input
                        type="time"
                        className="form-control"
                        id="minutos"
                        min="08:00"
                        onChange={(e) => setInicio(e.target.value)}
                        value={inicio}
                      />
                    </div>

                    <div className="p-2">
                      <label htmlFor="fin" className="form-label">
                        Hora de Fin
                      </label>
                      <input
                        type="time"
                        className="form-control"
                        id="fin"
                        min={inicio}
                        onChange={(e) => setFin(e.target.value)}
                        value={fin}
                      />
                    </div>
                    <div className="p-2">
                      <button
                        type="submit"
                        className={`btn form-control ${tieneConflicto ? "btn-danger" : "btn-success"}`}
                        disabled={tieneConflicto}
                      >
                        {tieneConflicto ? "Ya Existe una Reserva en ese Horario" : "Crear Solicitud Reserva"}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-12 col-lg-6 text-light bg-dark p-4" style={{ borderRadius: 10 }}>
                  <img
                    src={img2}
                    className="img-fluid"
                    alt=""
                    style={{ width: "100%", maxHeight: 250, objectFit: "cover", borderRadius: 8 }}
                  />
                  <div
                    className="mt-3"
                    style={{
                      backgroundColor: "#101722",
                      border: "1px solid rgba(255,255,255,0.1)",
                      borderRadius: 8,
                      padding: 10,
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-light"
                        disabled={!canGoToPreviousMonth}
                        onClick={() => {
                          if (!canGoToPreviousMonth) return;

                          setCalendarMonth(
                            (prev) => new Date(prev.getFullYear(), prev.getMonth() - 1, 1)
                          );
                        }}
                      >
                        &lt;
                      </button>

                      <strong style={{ fontSize: 13 }}>
                        {MONTHS_ES[calendarMonth.getMonth()]} {calendarMonth.getFullYear()}
                      </strong>

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-light"
                        onClick={() => {
                          setCalendarMonth(
                            (prev) => new Date(prev.getFullYear(), prev.getMonth() + 1, 1)
                          );
                        }}
                      >
                        &gt;
                      </button>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(7, 1fr)",
                        gap: 4,
                        fontSize: 12,
                      }}
                    >
                      {WEEK_DAYS.map((weekDay) => (
                        <div key={weekDay} style={{ textAlign: "center", color: "#9fb2c3", fontWeight: 600 }}>
                          {weekDay}
                        </div>
                      ))}

                      {calendarCells.map((dayNumber, index) => {
                        if (!dayNumber) {
                          return <div key={`empty-${index}`} style={{ height: 28 }} />;
                        }

                        const dayDate = new Date(
                          calendarMonth.getFullYear(),
                          calendarMonth.getMonth(),
                          dayNumber
                        );
                        const isPastDay = dayDate < todayDate;

                        const status = isPastDay ? "none" : getDayStatus(dayNumber);
                        const dayKey = `${calendarMonth.getFullYear()}-${pad2(calendarMonth.getMonth() + 1)}-${pad2(dayNumber)}`;
                        const isSelected = selectedDayKey === dayKey;
                        const isInspected = inspectedDayKey === dayKey;

                        let backgroundColor = "transparent";
                        let border = isSelected
                          ? "1px solid #3da5ff"
                          : "1px solid rgba(255,255,255,0.12)";
                        let textColor = "#dbe6f0";

                        if (status === "busy") {
                          backgroundColor = "#b42318";
                          border = isSelected ? "1px solid #ffd9d6" : "1px solid rgba(255,255,255,0.2)";
                          textColor = "#ffffff";
                        }

                        if (status === "partial") {
                          backgroundColor = "#1f8f4d";
                          border = isSelected ? "1px solid #d2ffe3" : "1px solid rgba(255,255,255,0.2)";
                          textColor = "#ffffff";
                        }

                        if (isPastDay) {
                          backgroundColor = "transparent";
                          border = "1px solid rgba(255,255,255,0.08)";
                          textColor = "#7d8ea0";
                        }

                        if (!isPastDay && isInspected) {
                          border = "2px solid #7dd3fc";
                        }

                        return (
                          <div
                            key={dayKey}
                            onClick={() => {
                              if (isPastDay) return;
                              setInspectedDayKey(dayKey);
                              setDia(dayKey);
                            }}
                            onKeyDown={(event) => {
                              if (isPastDay) return;
                              if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                setInspectedDayKey(dayKey);
                                setDia(dayKey);
                              }
                            }}
                            role={isPastDay ? undefined : "button"}
                            tabIndex={isPastDay ? -1 : 0}
                            style={{
                              height: 28,
                              borderRadius: 6,
                              backgroundColor,
                              border,
                              color: textColor,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 600,
                              cursor: isPastDay ? "default" : "pointer",
                            }}
                            title={
                              isPastDay
                                ? "Fecha pasada"
                                : status === "busy"
                                ? "Reservada con la misma hora de inicio"
                                : status === "partial"
                                ? "Reservada, pero con horas libres"
                                : "Sin reservas aceptadas"
                            }
                          >
                            {dayNumber}
                          </div>
                        );
                      })}
                    </div>

                    <div className="mt-2" style={{ fontSize: 11, color: "#d6e2ee" }}>
                      <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <span style={{ width: 10, height: 10, borderRadius: 2, background: "#1f8f4d", display: "inline-block" }} />
                        Dia reservado con horas libres
                      </div>
                      <div className="d-flex align-items-center mt-1" style={{ gap: 6 }}>
                        <span style={{ width: 10, height: 10, borderRadius: 2, background: "#b42318", display: "inline-block" }} />
                        Coincide con hora de inicio seleccionada
                      </div>
                      <div className="mt-1" style={{ color: "#9fb2c3" }}>
                        Clic en un dia para ver horarios ocupados.
                      </div>
                      {calendarLoading && (
                        <div className="mt-1" style={{ color: "#9fb2c3" }}>
                          Consultando disponibilidad...
                        </div>
                      )}
                    </div>

                    <div
                      className="mt-2 text-start"
                      style={{
                        backgroundColor: "rgba(16,23,34,0.75)",
                        border: "1px solid rgba(255,255,255,0.08)",
                        borderRadius: 8,
                        padding: "10px 12px",
                      }}
                    >
                      <div style={{ fontSize: 12, color: "#9fb2c3", marginBottom: 6 }}>
                        <strong>Horarios ocupados</strong>
                        {inspectedDayLabel ? ` - ${inspectedDayLabel}` : ""}
                      </div>

                      {!inspectedDayKey && (
                        <div style={{ fontSize: 13, color: "#c8d6e5" }}>
                          Selecciona un dia del calendario para ver los bloques reservados.
                        </div>
                      )}

                      {inspectedDayKey && inspectedReservations.length === 0 && (
                        <div style={{ fontSize: 13, color: "#9fb2c3" }}>
                          No hay reservas aceptadas ese dia.
                        </div>
                      )}

                      {inspectedDayKey && inspectedReservations.length > 0 && (
                        <div style={{ display: "grid", gap: 6 }}>
                          {inspectedReservations.map((reservation, index) => (
                            <div
                              key={`${reservation.start}-${reservation.end || "sin-fin"}-${index}`}
                              style={{
                                border: "1px solid rgba(125, 211, 252, 0.25)",
                                background: "rgba(30, 64, 175, 0.18)",
                                borderRadius: 6,
                                padding: "6px 8px",
                                fontSize: 13,
                                color: "#e3f2ff",
                              }}
                            >
                              {toReadableHour(reservation.start)}
                              {reservation.end ? ` - ${toReadableHour(reservation.end)}` : ""}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className="mt-3 text-start"
                    style={{
                      backgroundColor: "rgba(16,23,34,0.75)",
                      border: "1px solid rgba(255,255,255,0.08)",
                      borderRadius: 8,
                      padding: "10px 12px",
                      fontSize: 15,
                    }}
                  >
                    <div style={{ marginBottom: 6 }}><strong>Edificio:</strong> {Edificio}</div>
                    <div style={{ marginBottom: 6 }}><strong>N° de Piso:</strong> {N_piso}</div>
                    <div style={{ marginBottom: 6 }}><strong>Tamaño de Sala:</strong> {Tamaño}</div>
                    <div style={{ marginBottom: 6 }}><strong>N° de personas:</strong> {N_personas}</div>
                    <div style={{ marginBottom: 0 }}><strong>Estado:</strong> {Estado}</div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );


}

export default Card